import { CustomEvent, PageViews } from '@piwikpro/react-piwik-pro';

export const trackPageView = page => {
  PageViews.trackPageView(page);
};

export const trackEvent = event => {
  CustomEvent.trackEvent(event.event_category, event.action, event.event_label);
};
